"use strict";
/// <reference path="irep.js"/>

IREP.toolsEdit = (function () {
    var _tagAnimationSpeed = 500;
    var defaultSearchValue = "";
    var toolFiles = {};
    var showNewTags = false;

    var initRepeater = function () {
        $(".dvToolItem").hover(
            function () {
                $(this).find(".HoverTextHolder").show().css("display", "table");
            },
            function () {
                $(this).find(".HoverTextHolder").hide();
            }
        );
        
        $(".dvToolItem").on('click', function () {
            //Scrape Data
            scrapeAndDisplayData($(this));
            showDrawer($(this));
        });
    };
    
    var init = function (newTags) {        
        showNewTags = newTags.toLowerCase() == 'true' ? true : false;

        var isActive = "survey-Panel",
        img_src = "",
        new_src = "";
        $(".mouseover").hover(function () {
            img_src = $(this).attr('src');
            new_src = $(this).attr('rel');
            $(this).attr('src', new_src);
            $(this).attr('rel', img_src);
        },
       function () {
           $(this).attr('src', img_src);
           $(this).attr('rel', new_src);
       });

        var cache = new Array();
        $(".mouseover").each(function () {
            var cacheImage = document.createElement('img');
            cacheImage.src = $(this).attr('rel');
            cache.push(cacheImage);
        });

        $(".detail-Panel").show();
        $(".close-Panel").on('click', function () {
            closeModal();
        });

        $(".ModalView").click(function () {
            closeModal();
        });

        $(".detailInfo").click(function () {
            isActive = "detail-Panel";
            $(".detail-Panel").fadeIn(800, function () { });
            $(".close-Panel").fadeIn(800, function () { });
            $(".quotes-Panel").hide();
            $(".survey-Panel").hide();
        });        
    };

    /*
    * Log download of tool to DB for reporting. 
    */
    var postToolLog = function (toolId) {
        var params = { toolId: toolId };
        IREP.callApi("tools/logDownload", "POST", params);
    };

    $("#btnAddNew").click(function () {
        var tl = new TimelineMax();
        tl.insert(TweenMax.to($(".ModalView"), .4, { autoAlpha: 0.4, display: 'block' }), 0);        
        tl.insert(TweenMax.to($(".toolsDetailContainer"), .4, { height: "600px", autoAlpha: 1, display: 'block' }), 0);
        $("#toolPublishedDate").val(moment(new Date()).format("MM/DD/YYYY"));
        $("#toolDescription").val("");
        $("#toolName").val("");
        $("#toolId").val(-1);
        $("#toolCode").val("");
        $("#toolHighlighted").removeAttr("Checked");
        $("#toolFiles").empty();
        $(".toolFilesHeader").hide();
        tl.play();
    });

    $("#Files").click(function () {
        $("#toolsFileWrapper").show();
        $("#toolTagsWrapper").hide();

        $("#Files").addClass("selected");
        $("#Tags").removeClass("selected");
    });

    $("#Tags").click(function () {
        $("#toolsFileWrapper").hide();
        $("#toolTagsWrapper").show();

        $("#Tags").addClass("selected");
        $("#Files").removeClass("selected");
    });

    var scrapeAndDisplayData = function (activeSelector) {
        var dataUrl = $(activeSelector).attr('data-url');
        var dataTitle = $(activeSelector).attr('data-Title');
        var dataCode = $(activeSelector).attr('data-toolcode');
        var dataPublishdate = $(activeSelector).attr('data-publishdate');
        var dataImgUrl = $(activeSelector).attr('data-imgurl');
        var dataDesc = $(activeSelector).attr('data-desc');
        var dataId = $(activeSelector).attr('data-Id');
        var dataType = $(activeSelector).attr('data-displaytype');
        var hoverText = $(activeSelector).find(".HoverText").text();
        var hoverTextTrim = $.trim(hoverText);
        var dataIsNew = $(activeSelector).find(".newTool").text();
        var NewTrim = $.trim(dataIsNew);
        var dataHighlighted = $(activeSelector).attr('data-highlighted');
        var dataTags = $(activeSelector).attr('data-tags');
        var filterCollectionID = $(activeSelector).attr('data-filterCollectionId');
        
        $("#currentTagsList option").remove().appendTo("#allTagsList");

        
        loadCurrentTags(dataId, filterCollectionID);
        
        if (NewTrim === "New") {
            $(".newtraining").show();
        } else {
            $(".newtraining").hide();
        }
        $("#toolDescription").val(dataDesc);
        $("#toolPublishedDate").val(dataPublishdate);
        $("#toolName").val(dataTitle);
        $("#toolId").val(dataId);
       
        $("#toolCode").val(dataCode);

        $(".contentType").html(dataType);

        if (dataHighlighted.toLowerCase() === 'true') {
            $("#toolHighlighted").attr("Checked", dataHighlighted);
        } else {
            $("#toolHighlighted").removeAttr("Checked");
        }

        loadToolFiles(dataId);

        $(".tray-HoverText").text(hoverText);

    }

    var loadCurrentTags = function (dataId, filterCollectionId) {
        
        if (showNewTags) {
            $("#oldTags").hide();
            if (filterCollectionId > 0) {
                var url = IREP.generateSiteLink("/editor/filters/" + filterCollectionId);
                $("#newTags").show().load(url);
            } else {

                IREP.callApi("Filters/NewFilterCollection",
                        "POST",
                        {
                            filterType: 'tools',
                            id: dataId
                        }).done(function (data) {
                            if (data !== null) {

                                var url = IREP.generateSiteLink("/editor/filters/" + data.filterCollectionId);

                                $("#newTags").show().load(url);
                                
                            }
                        });

            }
        } else {
            $("#newTags").hide();
            $("#oldTags").show();
            
        }
    }

    $("#addTag").click(function () {
        var newId = $("#allTagsList").val();
        var toolid = $("#toolId").val();
        // add the new tag;
        IREP.callApi({ url: "tools/addTag", type: "POST", data: { "toolId": toolid, "tagId": newId } })
           .done(function (data) {
               $("#currentTagsList").append($("#allTagsList option:selected").clone());
               $("#allTagsList option:selected").remove();
           });
    });

    $("#removeTag").click(function () {
        var removeId = $("#currentTagsList").val();
        var toolid = $("#toolId").val();
        //remove the existing tag
        IREP.callApi({ url: "tools/removeTag", type: "POST", data: { "toolId": toolid, "tagId": removeId } })
           .done(function (data) {
               $("#allTagsList").append($("#currentTagsList option:selected").clone());
               $("#currentTagsList option:selected").remove();
           });
    });

    var loadToolFiles = function (dataId) {

        $("#toolFiles").empty();
        $("#Files").click();

        IREP.callApi({ url: "tools/toolFiles", type: "GET", data: { "toolId": dataId } })
           .done(function (data) {

               toolFiles = data;
               $.each(data.data, function (index, value) {
                   $("#toolFiles").append("<div id='row" + index + "' class='toolFileRow' data-fileID='" + value.id + "' data-thumbnail='" + value.thumbnail + "' data-geocode='" + ((value.geoCode) ? value.geoCode : "") + "' data-culturecode='" + ((value.cultureCode) ? value.cultureCode : "") + "' data-countrycode='" + ((value.countryCode) ? value.countryCode : "") + "' data-usertype='" + ((value.userType) ? value.userType : "") + "' data-custom1='" + ((value.custom1) ? value.custom1 : "") + "' data-custom2='" + ((value.custom2) ? value.custom2 : "") + "' data-url='" + value.url + "' data-active='" + value.active + "' data-largeimage='" + ((value.largeImgUrl) ? value.largeImgUrl : "") + "' data-typename='" + value.downloadType + "' data-formatid='" + value.formatID + "' data-active='" + value.active + "'   ></div>");
                   $("#row" + index).append('<div><a style="color: white" href="' + IREP.generateSiteLink("/learn/tool?preview=true&code=" + value.uid) + '">Preview</a></div>');
                   $("#row" + index).append("<div class='toolFileThumbnail' ><img src='" + value.thumbnail + "' /></div>");
                   $("#row" + index).append("<div class='toolFileDetails' id='toolFileDetails" + index + "'></div>");
                   $("#toolFileDetails" + index).append("<div>" + ((value.geoCode) ? value.geoCode + "/" : "") + ((value.cultureCode) ? value.cultureCode + "/" : "") + ((value.countryCode) ? value.countryCode + "/" : "") + ((value.userType) ? value.userType + "/" : "") + ((value.custom1) ? value.custom1 + "/" : "") + ((value.custom2) ? value.custom2 : "") + "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;UID: " + value.uid + "</div>");
                   $("#toolFileDetails" + index).append("<div>" + value.url + "</div>");
                   if (value.largeImgUrl) {
                       $("#toolFileDetails" + index).append("<div>" + value.largeImgUrl + "</div>");
                   }
                   $("#toolFileDetails" + index).append("<div>" + (value.active == 1 ? "Active" : (value.active == 2 ? "Preview" : "Innactive")) + "</div>");

               });

               $(".toolFileRow").click(function () {
                   editToolFile($(this));
               });

           });
    }

    var editToolFile = function (ctrl) {

        var fileId = ctrl.attr("data-fileid");
        var thumbnail = ctrl.attr("data-thumbnail");
        var geocode = ctrl.attr("data-geocode");
        var culturecode = ctrl.attr("data-culturecode");
        var countrycode = ctrl.attr("data-countrycode");
        var usertype = ctrl.attr("data-usertype");
        var custom1 = ctrl.attr("data-custom1");
        var custom2 = ctrl.attr("data-custom2");
        var url = ctrl.attr("data-url");
        var largeimage = ctrl.attr("data-largeimage");
        var active = ctrl.attr("data-active");
        var formatid = ctrl.attr("data-formatid");
        var downloadtype = ctrl.attr("data-typename");

        $("#toolFileThumbnail").val(thumbnail);
        $("#toolFileLargeImage").val(largeimage);
        $("#toolFileUrl").val(url);
        $("#toolFileDownloadType").val(downloadtype);
        $("#toolFileFormatId").val(formatid);

        $("#strCulture").val(culturecode);
        if (culturecode != "") {
            $("#chkCulture").attr("Checked", true);
        } else {
            $("#chkCulture").removeAttr("Checked");
        }
        $("#strCountries").val(countrycode);
        if (countrycode != "") {
            $("#chkCountries").attr("Checked", true);
        } else {
            $("#chkCountries").removeAttr("Checked");
        }
        $("#strGeo").val(geocode);
        if (geocode != "") {
            $("#chkGeo").attr("Checked", true);
        } else {
            $("#chkGeo").removeAttr("Checked");
        }
        $("#strUserType").val(usertype);
        if (usertype != "") {
            $("#chkUserType").attr("Checked", true);
        } else {
            $("#chkUserType").removeAttr("Checked");
        }

        $("#btnSaveToolFile").attr({"data-fileid" : fileId, "data-toolid" : toolId});

         $("#toolFileActive").val(active);
       

        $(".detailTop").slideUp();
        $("#tabRow").slideUp();
        $("#toolFileEdit").slideDown();
    }
    
    var showDrawer = function (ctrl) {
        // var detailDiv = $("div.DetailView[actcode='" + ctrl.attr("actcode") + "']").first();
        var borderWrapper = ctrl.find("*").addBack().filter(".borderWrapper");

        /* Hide video player if visible */
        $("#searchResults").show();
        $(".detailInfo").click(); //Force initial display to be the details of the tool
        $(".surveyContainer").html(""); //Remove the survey container's contents, so that it'll reload when you click it again. 
        $("#savesuccess").hide();


        var tl = new TimelineMax();
        if (ctrl.attr("ClickedImageTitle") == 'true') {
            tl.insert(TweenMax.to(borderWrapper, .1, { css: { border: "5px solid white", marginLeft: "0px", marginTop: "0px", marginRight: "0px", marginBottom: "0px" } }), 0);
            tl.insert(TweenMax.to($(".toolsDetailContainer"), .4, { height: 0, autoAlpha: 0, display: 'none' }), 0);
            tl.insert(TweenMax.to($(".ModalView"), .4, { display: 'none', autoAlpha: 0 }), 0);
            ctrl.attr("ClickedImageTitle", "false");
            ctrl.css("z-index", 0);
            $("#scrollSpacer").css("height", "0px");
            $("#closeFilters").click();
        } else {
            ctrl.css("z-index", 91);
            tl.insert(TweenMax.to($(".ModalView"), .4, { autoAlpha: 0.4, display: 'block' }), 0);
            tl.insert(TweenMax.to(borderWrapper, .1, { css: { border: "10px solid #00adef", marginLeft: "-5px", marginTop: "-5px", marginRight: "-5px", marginBottom: "-5px" } }), 0);
            tl.insert(TweenMax.to($(".toolsDetailContainer"), .4, { height: "600px", autoAlpha: 1, display: 'block', onComplete: scrollItemToDrawer, onCompleteParams: [ctrl] }), 0);

            ctrl.attr("ClickedImageTitle", "true");
            $(".detailTop").slideDown();
            $("#tabRow").slideDown();
            $("#toolFileEdit").slideUp();
        }
        tl.play();
        
        
    }

    var popup;
    var popupWindow = function (url, image) {
        $("#selectedImage").val(image);

        if (!popup) {
            popup = window.open(url, '_blank', 'toolbar=no, directories=no, location=no, status=yes, menubar=no, resizable=no, scrollbars=yes, width=900, height=600, modal=yes');
        }
        else {
            popup.Focus();
        }
    }        

    $(".imgButton").click(function () {
        popupWindow('SelectImage', $(this).attr("data-type"));
    });

    $("#uploadImagesThumbnail, #uploadImagesLarge").click(function () {        
        popupWindow('UploadImages');
    });

    $("#btnSelect").click(function () {
        //get the value, add it to the end of the string
        var filter = $(".Available:visible").attr("data-ftype");
        
        var current = $("#str" + filter).val();
        
        if (current == "") {
            current = "|" + $(".Available:visible").val() + "|";
        } else {
            current += $(".Available:visible").val() + "|";
        }

        $("#str" + filter).val(current);
        
        //remove the item from the list, append it to the selected list
        $(".Chosen:visible").append($(".Available:visible option:selected").clone());
        $(".Available:visible option:selected").remove();

        // check the checkbox 
        $("#chk" + filter).attr("Checked", true);
    });


    $("#btnDeSelect").click(function () {

        //get the value, add it to the end of the string
        var filter = $(".Available:visible").attr("data-ftype");

        //remove the item from the list, append it to the selected list
        $(".Available:visible").append($(".Chosen:visible option:selected").clone());
        $(".Chosen:visible option:selected").remove();

        var current = "|";

        $(".Chosen:visible option").each(function () {
            current += $(this).val() + "|";
        });

        $("#str" + filter).val(current);

        // uncheck the checkbox if the box is empty
        if ($(".Chosen:visible option").size() == 0) {
            $("#chk" + filter).removeAttr("Checked");
            $("#str" + filter).val("");
        }
    });

    $("#closeFilters").click(function () {
        $(".topContent").slideDown();
        $(".middleContent").slideUp();

        if ($(".Chosen:visible option").size() == 0) {
            // uncheck the checkbox
            $("#chk" + $(".Chosen:visible").attr("data-ftype")).removeAttr("Checked");
        }
        $(".Chosen:visible option").remove().appendTo(".Available:visible");
        $(".ruleSelect").hide();
    });

    $(".openFilters").click(function () {

        var type = $(this).attr("data-ftype");
        var current = $("#str" + type).val();
        var arr = current.split('|');

        $(".Chosen:visible option").remove().appendTo(".Available:visible");
        
        $.each(arr, function (index, value) {
            if (value != "") {                
                //console.log(index, value, $('#lst' + type + ' option[value="' + value + '"]'));
                $("#lst" + type + "Selected").append($('#lst' + type + ' option[value="' + value + '"]').clone());
                $('#lst' + type + ' option[value="' + value + '"]').remove();
            }
        });

        $(".topContent").slideUp();
        $(".middleContent").slideDown();
                
        $("#lst" + type).show();
        $("#lst" + type + "Selected").show();
    });

    $("#btnSaveTool").on("click", function () {

            var toolData = {
                description: $("#toolDescription").val(),
                sortDate: moment(new Date($("#toolPublishedDate").val())).format("YYYY-MM-DD"),
                name: $("#toolName").val(),
                toolId: $("#toolId").val(),
                toolCode: $("#toolCode").val(),
                highlighted: $("#toolHighlighted").is(':checked')
            };
            $("#savesuccess").html("Saving...").css({ "display": "inline-block" });

            IREP.callApi({ url: "tools/UpdateTool", type: "POST", data: toolData })
                .done(function (data) {
                    updateElement(toolData);
                    if (toolData.toolId == -1) {
                        IREP.callApi({ url: "tools/UpdateToolFile", type: "POST", data: { Id: -1, Thumbnail: "PLACEHOLDER", Url: "PLACEHOLDER", ToolId: data.data.toolId, FormatId: 1 } })
                           .done(function (toolFiledata) {
                               loadToolFiles(data.data.toolId);
                           });
                    }
                    $("#toolId").val(data.data.toolId);
                    $(".toolFilesHeader").show();
                    $("#savesuccess").html("Success!").css({"display": "inline-block"});
                }).fail(function (jqXHR, textStatus, errorThrown) {
                    alert('An error has occured');
                    console.log(jqXHR, textStatus, errorThrown);
                });
        
    });


    $("#btnSaveToolFile").on("click", function () {
        
        var toolFileData = {
            Thumbnail: $("#toolFileThumbnail").val(),
            LargeImgUrl: $("#toolFileLargeImage").val(),
            Url: $("#toolFileUrl").val(),
            DownloadType: $("#toolFileDownloadType").val(),
            FormatID: $("#toolFileFormatId").val(),

            CultureCode: $("#strCulture").val(),
            CountryCode: $("#strCountries").val(),
            GeoCode: $("#strGeo").val(),
            UserType: $("#strUserType").val(),
            Custom1: $("#toolFileCustom1").val(),
            Custom2: $("#toolFileCustom2").val(),

            Active: $("#toolFileActive").val(),
            Id: $("#btnSaveToolFile").attr("data-fileid"),
            ToolId: $("#toolId").val()

        };

        if (toolFileData.Tumbnail == "" || toolFileData.Url == "") {
            alert("Thumbnail and File URL are required!");
            return;
        }

        $("#closeFilters").click();

        IREP.callApi({ url: "tools/UpdateToolFile", type: "POST", data: toolFileData })
           .done(function (data) {
               loadToolFiles(toolFileData.ToolId);
               $(".detailTop").slideDown();
               $("#tabRow").slideDown();
               $("#toolFileEdit").slideUp();
           }).fail(function (jqXHR, textStatus, errorThrown) {
               alert('An error has occured');
               console.log(jqXHR, textStatus, errorThrown);
           });
    });

    $("#addNewFile").click(function () {
        $("#toolFileThumbnail").val("");
        $("#toolFileLargeImage").val("");
        $("#toolFileUrl").val("");
        $("#toolFileDownloadType").val("");
        $("#toolFileFormatId").val(1);

        $("#toolFileCultureCode").val("");
        $("#toolFileCountryCode").val("");
        $("#toolFileGeoCode").val("");
        $("#toolFileUserType").val("");
        $("#toolFileCustom1").val("");
        $("#toolFileCustom2").val("");

        $("#toolFileActive").val();
        $("#btnSaveToolFile").attr({ "data-fileid": -1 });

        $(".detailTop").slideUp();
        $("#tabRow").slideUp();
        $("#toolFileEdit").slideDown();
    });

    $("#btnCancelToolFile").click(function () {
        $(".detailTop").slideDown();
        $("#tabRow").slideDown();
        $("#toolFileEdit").slideUp();
        $("#closeFilters").click();
    });

    $("#reloadTools").click(function() {
        $(this).closest('form')[0].submit();
    });

    var updateElement = function (toolData) {
        if (toolData.highlighted) {
            $("#" + toolData.toolId).find("#overlay").removeClass("hideMe");
        } else {
            $("#" + toolData.toolId).find("#overlay").addClass("hideMe");
        }
        $("#" + toolData.toolId).attr({ "data-desc": toolData.description })
                            .attr({ "data-title": toolData.name })
                            .attr({ "data-highlighted": toolData.highlighted })
                            .attr({ "data-toolcode": toolData.toolCode })
                            .attr({ "data-publishdate": toolData.sortDate });
    }

    var scrollItemToDrawer = function (ctrl) {
        var ControlToUse = ctrl.find("*").addBack().filter(".borderWrapper");
        if (ControlToUse.offset().top + ControlToUse.outerHeight() < $(".toolsDetailContainer").offset().top) {
            $("html,body").animate({ scrollTop: $(window).scrollTop() - ($(".toolsDetailContainer").offset().top - ControlToUse.offset().top - ControlToUse.outerHeight()) }, 'fast');
        }
        else {
            $("#scrollSpacer").css("height", (ControlToUse.offset().top + ControlToUse.outerHeight()) - $(".toolsDetailContainer").offset().top + 150);
            $("html,body").animate({ scrollTop: $(window).scrollTop() + (ControlToUse.offset().top + ControlToUse.outerHeight() - $(".toolsDetailContainer").offset().top) }, 'fast');
        }
    }

    var closeModal = function () {
        var tl = new TimelineMax();
        $(".detailActivityCommentsWrapper").slideUp();
        tl.insert(TweenMax.to($(".borderWrapper"), .1, { css: { border: "5px solid white", marginLeft: "0px", marginTop: "0px", marginRight: "0px", marginBottom: "0px" } }), 0);
        tl.insert(TweenMax.to($(".toolsDetailContainer"), .4, { height: 0, autoAlpha: 0, display: 'none' }), 0);
        tl.insert(TweenMax.to($(".ModalView"), .4, { display: 'none', autoAlpha: 0 }), 0);
        $(".ImageAndTitleView, .dvToolItem").attr("ClickedImageTitle", "false");
        $(".ImageAndTitleView, .dvToolItem").css("z-index", 0);
        tl.play();
        $("#scrollSpacer").css("height", "0px");
        $("#savesuccess").hide();
        $("#closeFilters").click();
    }

    return {
        init: init,
        initRepeater: initRepeater
    };
})();